import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import HeroBanner from "./HeroBanner";
import BookingWidget from "./BookingWidget";

const ScandinavianAirlines = () => {
    useEffect(() => {
        // Apply SAS-specific styles to body when component mounts
        document.body.style.backgroundColor = "#f5f5f5";
        document.body.style.color = "#333333";

        // Cleanup function to reset styles when component unmounts
        return () => {
            document.body.style.backgroundColor = "";
            document.body.style.color = "";
        };
    }, []);

    return (
        <div
            className="min-h-screen bg-sas-gray"
            style={{
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            }}
        >
            <Sidebar activeItem="Book" isCollapsed={false} />
            <Header />

            <main className="ml-60 pt-16 min-h-screen">
                {/* Hero Banner */}
                <HeroBanner />

                {/* Booking Widget - overlays on hero banner */}
                <BookingWidget />
            </main>
        </div>
    );
};

export default ScandinavianAirlines;
